// Generated by Melange

import * as Buhta_cabinet__Control from "../../grpc/Control.js";
import * as Buhta_cabinet__LoadingSpinner from "../../components/atoms/LoadingSpinner.js";
import * as Buhta_cabinet__OrgDashboardPage from "../OrgDashboardPage/OrgDashboardPage.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(id) {
  return function (route) {
    const func = Buhta_cabinet__Control.OrgService.view;
    const match = Buhta_core__GrpcState.useModel((function (param) {
            return Curry._3(func, param, {
                        hd: "bank_account",
                        tl: {
                          hd: "chief",
                          tl: /* [] */0
                        }
                      }, id);
          }), undefined);
    const dispatch = match[1];
    const model = match[0];
    React.useEffect((function () {
            Curry._2(dispatch, undefined, undefined);
          }), [id]);
    if (typeof model === "string") {
      return JsxRuntime.jsx(Buhta_cabinet__LoadingSpinner.make, {});
    }
    if (model.NAME !== "Data") {
      return JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  children: "error"
                });
    }
    const org = model.VAL;
    const profile_id = org.id;
    const profile_country = org.country;
    const profile_type$p = org["type'"];
    const profile_name = org.name;
    const profile_tin = org.tin;
    const profile = {
      id: profile_id,
      country: profile_country,
      "type'": profile_type$p,
      name: profile_name,
      tin: profile_tin
    };
    return JsxRuntime.jsx(Buhta_cabinet__OrgDashboardPage.make, {
                org: profile,
                route: route
              });
  };
}

function OrgViewPage(Props) {
  return make(Props.id)(Props.route);
}

const make$1 = OrgViewPage;

export {
  make$1 as make,
}
/* Buhta_cabinet__Control Not a pure module */
